import {z} from '@hono/zod-openapi';

import {identifiers} from './identifiers';

export const InventoryValueQuerySchema = z
  .object({
    asOf: z.string().date().optional().openapi({example: '2026-09-07'}),
    warehouse: identifiers,
    branch: identifiers,
    months: z.coerce.number().int().min(1).max(12).default(12),
  })
  .openapi('InventoryValueQuery');

export type InventoryValueQuery = z.infer<typeof InventoryValueQuerySchema>;
